import * as Yup from 'yup';

export const lenderELTEditorValidationSchema = Yup.object().shape({
	stateSpecificEltCode : Yup.object().shape({
		eltCode        : Yup.string().nullable().max(128, 'ELT Code should be max 128 symbols'),
		name           : Yup.string().required('Lender is required'),
		lenderName     : Yup.string().nullable().name(),
		lenderAddress  : Yup.string().nullable().max(128, 'Address should be max 128 symbols'),
		lenderState    : Yup.string().nullable(),
		lenderCity     : Yup.string().nullable().max(48, 'City should be max 48 symbols'),
		lenderPostCode : Yup.string().nullable().matches(/^\d{5}$|^\d{5}-\d{4}$/, 'Incorrect Zip format'),
		newState       : Yup.string().nullable(),
	})
});

